import * as Yup from 'yup';

const studentValidationSchema = Yup.object({
  firstName: Yup.string().required('First name is required'),
  lastName: Yup.string().required('Last name is required'),
  email: Yup.string().email('Invalid email format').required('Email is required'),
  studentId: Yup.string().required('Student ID is required'),
  grade: Yup.string().required('Grade is required'),
  // phoneNumber: Yup.string().required('Phone number is required'),
  password: Yup.string().min(6, 'Password should be at least 6 characters').required('Password is required'),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref('password')], 'Passwords must match')
    .required('Please confirm your password'),
});

// crete student edit scehama
const editProfileValidationSchema = Yup.object({
  firstName: Yup.string().required('First name is required'),
  lastName: Yup.string().required('Last name is required'),
  email: Yup.string().email('Invalid email format').required('Email is required'),
  studentId: Yup.string().required('Student ID is required'),
  grade: Yup.string().required('Grade is required'),
  phoneNumber: Yup.string().optional(),
  balance: Yup.string()
    .test('is-number', 'Balance must be a valid number', value => !value || !isNaN(parseFloat(value)))
    .optional(),
});

const loginValidationSchema = Yup.object({
  email: Yup.string().email('Invalid email format').required('Email is required'),
  password: Yup.string().min(6, 'Password should be at least 6 characters').required('Password is required'),
});

const forgotPasswordValidationSchema = Yup.object({
  email: Yup.string().email('Invalid email format').required('Email is required'),
});

const resetPasswordValidationSchema = Yup.object({
  password: Yup.string().min(6, 'Password should be at least 6 characters').required('Password is required'),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref('password')], 'Passwords must match')
    .required('Please confirm your password'),
});

const addBadgeValidationSchema = Yup.object({
  badgeName: Yup.string().required('Badge name is required'),
  description: Yup.string()
    .required('Description is required')
    .min(10, 'Description should be at least 10 characters long'),
});

const addstudentBehaviourSchema = Yup.object().shape({
  studentName: Yup.array()
    .min(1, 'Please select at least one student')
    .of(
      Yup.object().shape({
        label: Yup.string().required(),
        value: Yup.string().required(),
      })
    ),
  title: Yup.string().required('Title is required').min(3, 'Title should be at least 3 characters long'),
  type: Yup.string().required('Type is required'),
  description: Yup.string()
    .required('Description is required')
    .min(10, 'Description should be at least 10 characters long'),
});

const assignNewChallengeValidationSchema = Yup.object({
  selectedStudents: Yup.array()
    .min(1, 'Please select at least one student')
    .of(
      Yup.object().shape({
        label: Yup.string().required('Student name is required'),
        value: Yup.string().required('Student ID is required'),
      })
    ),
  scenario: Yup.string().required('Scenario is required'),
  duration: Yup.string().required('Duration is required'),
  amount: Yup.number()
    .required('Amount is required')
    .positive('Amount must be positive')
    .integer('Amount must be a whole number')
    .min(1, 'Amount must be at least 1'),
});

const newTransactionValidationSchema = Yup.object({
  selectedStudents: Yup.array()
    .min(1, 'Please select at least one student')
    .of(
      Yup.object().shape({
        label: Yup.string().required('Student name is required'),
        value: Yup.string().required('Student ID is required'),
      })
    ),
  reason: Yup.string().required('Reason is required'),
  amount: Yup.number()
    .required('Amount is required')
    .positive('Amount must be positive')
    .integer('Amount must be a whole number')
    .min(1, 'Amount must be at least 1'),
});

const addClassSchema = Yup.object().shape({
  title: Yup.string().required('Title is required').min(3, 'Title should be at least 3 characters long'),
  teacherid: Yup.string().required('Teacher is required'),
  startTime: Yup.string()
    .required('Start time is required')
    .matches(/^([01]\d|2[0-3]):([0-5]\d)$/, 'Start time must be in HH:mm format'),
  endTime: Yup.string()
    .required('End time is required')
    .matches(/^([01]\d|2[0-3]):([0-5]\d)$/, 'End time must be in HH:mm format')
    .test('is-after-startTime', 'End time must be after start time', function (value) {
      const { startTime } = this.parent; // Access the sibling field (startTime)
      if (!startTime || !value) return true; // Skip if either field is empty
      return value > startTime; // Check if endTime is later than startTime
    }),
});

const changePasswordValidationSchema = Yup.object({
  newPassword: Yup.string().min(6, 'Password should be at least 6 characters').required('New Password is required'),
  reEnterPassword: Yup.string()
    .oneOf([Yup.ref('newPassword')], 'Passwords must match')
    .required('Please re-enter your password'),
});

export {
  studentValidationSchema,
  addBadgeValidationSchema,
  addstudentBehaviourSchema,
  assignNewChallengeValidationSchema,
  addClassSchema,
  editProfileValidationSchema,
  changePasswordValidationSchema,
  loginValidationSchema,
  forgotPasswordValidationSchema,
  resetPasswordValidationSchema,
  newTransactionValidationSchema
};
